import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import swal from "sweetalert2";
import { MatDialog } from '@angular/material/dialog';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { ApiService } from '../../../service/api.service';
import { HelperService } from '../../../service/helper.service';
import { EncryptionService } from '../../../service/encryption.service';
import { DeletePopupComponent } from '../../../popups/delete-popup/delete-popup.component';
import { F } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it' }
  ],
})
export class EditProfileComponent implements OnInit {

  sidebarMenuName: string;
  addCustomerForm: FormGroup;
  title = 'Add';
  topTitle2 = 'ORDERMANAGEMENT.MENUHOME';
  topTitle3 = 'ORDERMANAGEMENT.ADDUNIT';
  scopesList: any = [];
  categoryList: any = [];
  typeList: any = [];
  filterValuetypeList: any = [];
  paymentList: any = [];
  paymentFilterList: any = [];
  paymentMilestonesList: any = [];
  paymentMilestonesFilterList: any = [];
  paymentExclusionList: any = [];
  paymentExclusionFilterList: any = [];
  hoursDaysMonths = ["HOUR"];
  // "DAYS", "MONTHS"
  currency = ['EURO', 'USD'];
  //alphanumeric with letters
  AlphaNumeric: '^([a-zA-Z0-9]+)$';
  unitIdRequest: any;
  RecordFiltered: any[] = [];


  country: any[] = []
  countryRecordFiltered: any[] = [];
  region: any[] = [];
  regionRecordFiltered: any[] = [];
  provList = [];
  selectedStatesId: any;
  citiesRecord: any;
  citiesRecordFiltered: any;
  statesRecord: any;
  provListRecordFiltered: any[];
  companyId: any;
  resionId: any;
  provisionName: any;
  customerId: any;
  isCustomerOrderExists: any;
  @ViewChild('stepper') stepper!: MatStepper;
  isStep1Valid: boolean = false;
  isStep2Valid: boolean = false;
  isStep3Valid: boolean = false;
  isStep4Valid: boolean = false;
  internalPeopleList = [];
  customerDetail = null;

  countrySearchControl = new FormControl('');
  provinceSearchControl = new FormControl('');
  regionSearchControl = new FormControl('');
  citySearchControl = new FormControl('');

  constructor(
    private _formBuilder: FormBuilder,
    private helper: HelperService,
    public translate: TranslateService,
    private router: Router,
    public route: ActivatedRoute,
    private Api_Service: ApiService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private encryptionService: EncryptionService
  ) { }

  logout(): void {
    HelperService.onLogOut();
    this.router.navigate(['/']);
  }





  ngOnInit(): void {

    this.addCustomerForm = this._formBuilder.group({
      codeId: [''],
      companyName: ['', [HelperService.noWhitespaceValidator, Validators.required]],
      contactName: [''],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$')])],
      mobileNumber: [''],
      countryName: ['', [HelperService.noWhitespaceValidator, Validators.required]],
      region: ['', [Validators.required]],
      city: ['', [Validators.required]],
      province: ['', [Validators.required]],
      street: [''],
      zipCode: [''],
      sdi: [''],
      taxIdCode: [''],
      vatCode: [''],
      pecMail: ['', [ Validators.pattern('^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$')]],
      internalReference: [''],
      customerReferenceName: ['']
    });

    this.sideMenuName();
    const loginUser = this.encryptionService.getDataFromLocalStorage('NPLoginId');
    this.companyId = JSON.parse(loginUser);
    this.getDetails(this.companyId)

    this.sideMenuName()
    this.getcountryList({});

  }

  sideMenuName() {
    this.sidebarMenuName = this.translate.instant('ORDERMANAGEMENT.UNITMENU');
    //  this.helper.sideMenuListName.next(this.sidebarMenuName);
  }



  nextStep() {
    if (this.stepper.selectedIndex === 0 && this.addCustomerForm.controls['companyName'].valid &&
      this.addCustomerForm.controls['codeId'].valid &&
      this.addCustomerForm.controls['contactName'].valid && this.addCustomerForm.controls['email'].valid && this.addCustomerForm.controls['mobileNumber'].valid) {
      this.isStep1Valid = true; // Check validity of Step 1 form
      this.cdRef.detectChanges();
      this.stepper.next();
    }
    else if (this.stepper.selectedIndex === 1 && this.addCustomerForm.controls['countryName'].valid &&
      this.addCustomerForm.controls['region'].valid &&
      this.addCustomerForm.controls['province'].valid && this.addCustomerForm.controls['city'].valid
      && this.addCustomerForm.controls['street'].valid
      && this.addCustomerForm.controls['zipCode'].valid) {
      this.cdRef.detectChanges();
      this.stepper.next();
    }else {
      this.helper.showMandatoryFieldsPopup();
    }
  }

  clearSelection() {
    this.addCustomerForm.get('internalReference').setValue(null)
  }

  getDetails(userId) {
    this.Api_Service.getCustomerDetails(userId).subscribe((res: any) => {
      if (res.result && res.data) {
        const getRequestData = res.data;
        this.customerDetail = getRequestData;
        //  this.customerId= id;
        this.changeCountry(getRequestData.country, false);
        this.resionId = getRequestData.region;
        this.provisionName = getRequestData.province
        this.isCustomerOrderExists = res.data.isCustomerOrderExists;
        this.addCustomerForm.patchValue({
          codeId: getRequestData.codeId,
          companyName: getRequestData.companyName,
          contactName: getRequestData.contactName,
          email: getRequestData.email,
          mobileNumber: getRequestData.mobileNumber,
          countryName: getRequestData.country,
          region: getRequestData.region,
          city: getRequestData.city,
          province: getRequestData.province,
          street: getRequestData.street,
          zipCode: getRequestData.zipCode,
          internalReference: getRequestData.internalReference,
          customerReferenceName: getRequestData.customerReferenceName,
          pecMail: getRequestData.pecMail,
          vatCode: getRequestData.vatCode,
          taxIdCode: getRequestData.taxIdCode,
          sdi: getRequestData.sdi,
        });
        if (getRequestData?.internalReference) {
          this.internalPeopleList = [{name: getRequestData?.internalReferenceName, id: getRequestData?.internalReference}]
        } else {
          this.addCustomerForm.get('internalReference').disable()
        }

        this.helper.toggleLoaderVisibility(false);
      } else {
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant(res.reason),
          'info'
        );
      }
    });

  }


  prevState() {
    this.getDetails(this.companyId)
  }



  getcountryList(request) {
    this.helper.toggleLoaderVisibility(true);
    this.Api_Service.getCountryList().subscribe((res: any) => {
      if (res) {
        this.country = res.data;
        this.countryRecordFiltered = this.country.slice();
        this.helper.toggleLoaderVisibility(false);
      } else {
        this.helper.toggleLoaderVisibility(false);
        // const e = err.error;
        swal.fire(
          '',
          // err?.error?.message,
          this.translate.instant(res.reason),
          'info'
        );
      }
    })

    this.helper.toggleLoaderVisibility(false);
  }



  changeCountry(id: any, isChange) {
    this.helper.toggleLoaderVisibility(true);
    this.resetState(isChange)
    this.Api_Service.getStatesList({ countryID: id }).subscribe((res: any) => {
      if (res) {
        this.region = res.data;
        this.statesRecord = this.region;
        this.regionRecordFiltered = this.region.slice();
        this.helper.toggleLoaderVisibility(false);
        this.changeState(this.resionId, false);

      } else {
        this.helper.toggleLoaderVisibility(false);
        // const e = err.error;
        swal.fire(
          '',
          // err?.error?.message,
          this.translate.instant(res.reason),
          'info'
        );
      }
    })

    this.helper.toggleLoaderVisibility(false);
  }


  changeState(stateName, isChange) {
    const stateData = this.statesRecord;
    if (isChange) {
      this.addCustomerForm.patchValue({
        city: '',
        province: '',
      });
    }
    if (stateData) {
      for (let i = 0; i < stateData?.length; i++) {
        if (stateData[i].id == stateName) {
          this.selectedStatesId = stateData[i].id;
          this.Api_Service.getSelectedProvince({ id: stateName }).subscribe((data) => {
            this.provList = data.data.map((code: string, index: number) => ({
              id: index,      // or use code itself if it’s unique
              name: code      // display value
            }));
            this.provListRecordFiltered = this.provList.slice();
            this.changeProvince(this.provisionName, false)
          });
        }
      }
    }
  }

  changeProvince(provinceName, isChange) {
    const provData = this.provList;
    console.log(provinceName)
    if (isChange) {
      this.addCustomerForm.patchValue({
        city: '',
      });
    }
    // for (let i = 0; i < provData?.length; i++) {
    //   if (provData[i] == provinceName) {
    //     this.selectedStatesId = provData[i];
        this.Api_Service.getCitiesList({ province: provinceName }).subscribe((data) => {
          this.citiesRecord = data.data;
          this.citiesRecordFiltered = this.citiesRecord.slice();
        });
    //   }
    // }
  }




  trimFormValues(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control && control.value && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });
  }



  addCustomer() {
    // Trim form values before using them
    this.trimFormValues(this.addCustomerForm);

    let requestBody = {
      codeId: this.addCustomerForm.controls['codeId'].value ? this.addCustomerForm.controls['codeId'].value : '',
      companyName: this.addCustomerForm.controls['companyName'].value,
      email: this.addCustomerForm.controls['email'].value,
      contactName: this.addCustomerForm.controls['contactName'].value ? this.addCustomerForm.controls['contactName'].value : null,
      mobileNumber: this.addCustomerForm.controls['mobileNumber'].value ? this.addCustomerForm.controls['mobileNumber'].value : null,
      country: this.addCustomerForm.controls['countryName'].value,
      region: this.addCustomerForm.controls['region'].value,
      city: this.addCustomerForm.controls['city'].value,
      province: this.addCustomerForm.controls['province'].value,
      street: this.addCustomerForm.controls['street'].value ? this.addCustomerForm.controls['street'].value : '',
      zipCode: this.addCustomerForm.controls['zipCode'].value ? this.addCustomerForm.controls['zipCode'].value : '',
      customerReferenceName: this.addCustomerForm.controls['customerReferenceName'].value ? this.addCustomerForm.controls['customerReferenceName'].value : '',
      internalReference: this.addCustomerForm.controls['internalReference'].value ? this.addCustomerForm.controls['internalReference'].value : '',
      customerId: this.companyId,

      pecMail:  this.addCustomerForm.controls['pecMail'].value || "",
      vatCode:  this.addCustomerForm.controls['vatCode'].value || "",
      taxIdCode:  this.addCustomerForm.controls['taxIdCode'].value || "",
      sdi:  this.addCustomerForm.controls['sdi'].value || "",
    }

    if (this.addCustomerForm.valid) {
      this.helper.toggleLoaderVisibility(true);
      // update Customer
      this.Api_Service.updateCustomer(requestBody).subscribe((res: any) => {
        this.helper.toggleLoaderVisibility(false);
        if (res.result) {
          this.router.navigate(['/dashboard']);
          swal.fire('',
            this.translate.instant(res.message),
            'success');
        }
      }, (err) => {
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant(err.reason),
          'info'
        );
      });
    }

  }

  resetState(isChange) {
    if (isChange) {
      this.addCustomerForm.patchValue({
        region: '',
        city: '',
        province: '',
      });
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  space(event: any): void {
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault();
    }
  }


  deleteAccount() {
    let mymessage: string;
    if (this.isCustomerOrderExists) {
       mymessage = 'MYACCOUNT.CustomerOrderExists'
    } else {
      mymessage = 'MYACCOUNT.DeleteAccountWarning'
    }
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      panelClass: 'customer-delete-panel-modal',
      data: {
        message: this.translate.instant(mymessage),
        heading: this.translate.instant('MYACCOUNT.DeleteAccount'),
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.Api_Service.deleteProfile(this.companyId).subscribe((res: any) => {
          if (res) {
            this.logout();
            swal.fire('',
              this.translate.instant('MYACCOUNT.DeleteAccountSuccess'),
              'success');
          } else {
            this.helper.toggleLoaderVisibility(false);
            // const e = err.error;
            swal.fire(
              '',
              // err?.error?.message,
              this.translate.instant(res.reason),
              'info'
            );
          }
        })

      }
    });

  }


}
